export default {
  headers: {
    edit_time: 'Modifica orario',
    create_time: 'Crea orario',
  },
  labels: {
    select_all: 'Seleziona tutto',
  },
  buttons: {
    add_opening_time: 'Aggiungi orario di apertura',
    add: 'Aggiungi',
    cancel: 'Annulla',
  },
};
